<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        {{ $lang.diversityQuestions.explainer }}
        <br>
        <a
          target="_blank"
          href="/blog/privacy-policy/"
        >{{ $lang.diversityQuestions.privacyPolicy }}</a>
      </p>
      <div class="IncrementalData-question">
        <div class="Form-field">
          <label
            class="IncrementalData-questionText Form-label"
            for="ethnicity"
          >What is your ethnicity?</label>
          <div class="IncrementalData-questionField">
            <select
              id="ethnicity"
              v-model="fields.ethnicity"
              required
              @change="localValidationMessages.ethnicity = null"
            >
              <optgroup
                v-for="group in ethnicities"
                :key="group.id"
                :label="group.text"
              >
                <option
                  v-for="ethnicity in group.ethnicities"
                  :key="ethnicity.id"
                  :value="ethnicity.value"
                >
                  {{ ethnicity.text }}
                </option>
              </optgroup>
            </select>
          </div>
          <error-messages
            :errors="[validateStatus({ field: v$.fields.ethnicity, serverKey: 'ethnicity', label: 'Ethnicity' })][0]['errors']"
            :manual-validate="validateAll"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import errorMessages from '@/components/form/partials/error-message.vue';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    errorMessages,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        ethnicity: null,
      },
      fieldName: 'ethnicity',
      showLocalValidation: false,
      localValidationMessages: [],
    };
  },
  computed: {
    ...mapState('entities', {
      ethnicities: (state) => state.ethnicities,
    }),
    updatePayload() {
      return this.fields;
    },
  },
  mounted() {
    this.getEthnicities();
  },
  methods: {
    ...mapActions('entities', ['getEthnicities']),
  },
};
</script>
